import IconButton from "components/Button/IconButton";
import NotFound from "components/not-found/NotFound";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import Pagination from "react-js-pagination";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { RemoveRedEye } from "@mui/icons-material";
import { Button } from "components/Button/Button";
import Link from "components/Button/Link";
import { Badge } from "@mui/material";
import { useParams } from "react-router-dom";
import Switch from "components/Switch/Switch";
import ModalBox from "components/modal/ModalBox";
import { Input } from "components/Form";
import toast from "react-hot-toast";
import {
  getPostalCourseFiles,
  uploadFileToFolderForPostalCourse,
  deleteFileFromPostalCourseFolder,
  renameFileOrFolder,
} from "services/course/mappostaldocuments";
import { Tooltip } from "@mui/material";
import { encryptData } from "config/config";
import useCookie from "hooks/useCookie";
import FolderIcon from "@mui/icons-material/Folder";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";


export default function PostalCourseDocFiles() {
  const { document, pagename } = useParams();
  const [record, setRecord] = useState([{}]);
  const [limit, setLimit] = useState(10);
  const [activePage, setActivePage] = useState(1);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [data, setData] = useState({
    // question: EditorState.createEmpty(),
    // explaination: EditorState.createEmpty(),
  });
  const [errorField, setErrorField] = useState({});
  const [newFolderModal, setNewFolderModal] = useState(false);
  const [newFolderName, setNewFolderName] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);

  const [statusModal, setStatusModal] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [selectedId, setSelectId] = useState("");
  const [renameModal, setRenameModal] = useState(false);
  const [renameValue, setRenameValue] = useState("");
  const [itemToRename, setItemToRename] = useState(null); // store file/folder info
  const [itemToDelete, setItemToDelete] = useState(null); // store file/folder info


  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
  const [path, setPath] = useState(document || "");
  const [folders, setFolders] = useState([]);
  const { cookies } = useCookie();

  // ***************************************** Fetch Records ********************************************************
  const fetchRecords = async () => {
    showLoader();
    try {
      const res = await getPostalCourseFiles({
        document: path,
        page: activePage,
        search,
        limit,
      });

      hideLoader();
      if (res.code === 200) {
        const { items } = res.data;
        setRecord(items || []);   // now single list
        setTotal(items?.length || 0);
      } else {
        setRecord([]);
        setTotal(0);
      }
    } catch (err) {
      hideLoader();
      toast.error(err?.response?.data?.message || err.message);
    }
  };
  const handleUpload = async () => {
    showLoader();
    if (!newFolderName.trim()) {
      toast.error("Please enter a folder name");
      return;
    }
    try {
      showLoader();
      const formData = new FormData();
      // formData.append("docfile", files);
      formData.append("document", path || document);
      formData.append("subfolder", newFolderName);
      formData.append(
        "reqData",
        encryptData({
          access_token: cookies,
          document: path || document,
          subfolder: newFolderName
        })
      );
      const res = await uploadFileToFolderForPostalCourse(formData);
      hideLoader();
      if (res.code === 200) {
        toast.success("Folder created successfully");
        setNewFolderModal(false);
        fetchRecords(); // refresh list
      } else {
        toast.error(res.message || "Failed to create folder");
      }
    } catch (err) {
      hideLoader();
      toast.error(err?.response?.data?.message || err.message);
    }
  };
  const handleFileUpload = async () => {
    if (!selectedFile) {
      toast.error("Please select a file");
      return;
    }

    showLoader();
    try {
      const formData = new FormData();
      formData.append("docfile", selectedFile); // 👈 file
      formData.append("document", path || document); // main folder
      formData.append(
        "reqData",
        encryptData({
          access_token: cookies,
          document: path || document,
        })
      );

      const res = await uploadFileToFolderForPostalCourse(formData);

      hideLoader();
      if (res.code === 200) {
        toast.success("File uploaded successfully");
        setAddModal(false);
        setSelectedFile(null);
        fetchRecords(); // refresh table
      } else {
        toast.error(res.message || "Failed to upload file");
      }
    } catch (err) {
      hideLoader();
      toast.error(err?.response?.data?.message || err.message);
    }
  };
  const handleDelete = async () => {
    if (!itemToDelete) return;

    showLoader();
    try {
      const payload = {
        document: path || document,
        filename: itemToDelete.name,
        isFolder: itemToDelete.type === "folder"
      }
      const res = await deleteFileFromPostalCourseFolder(payload);

      hideLoader();
      if (res.code === 200) {
        toast.success(`${itemToDelete.type === "folder" ? "Folder" : "File"} deleted successfully`);
        setItemToDelete(null);
        fetchRecords();
      } else {
        toast.error(res.message || "Failed to delete");
      }
    } catch (err) {
      hideLoader();
      toast.error(err?.response?.data?.message || err.message);
    }
  };
  const handleRename = async () => {
    if (!renameValue.trim() || !itemToRename) {
      toast.error("Please enter a name");
      return;
    }

    const payload = {
      document: path || document,
      oldName: itemToRename.name,
      newName: renameValue,
      isFolder: itemToRename.type === "folder"
    }

    showLoader();
    try {

      const res = await renameFileOrFolder(payload);

      hideLoader();
      if (res.code === 200) {
        toast.success(`${itemToRename.type === "folder" ? "Folder" : "File"} renamed successfully`);
        setRenameModal(false);
        setItemToRename(null);
        setRenameValue("");
        fetchRecords();
      } else {
        toast.error(res.message || "Failed to rename");
      }
    } catch (err) {
      hideLoader();
      toast.error(err?.response?.data?.message || err.message);
    }
  };



  useEffect(() => {
    fetchRecords();
    console.log("path", path);

  }, [search, activePage, limit, path]);  // 👈 include path

  // ***************************************** Form validation ********************************************************
  const handleValidation = () => {
    let isError = false;
    const newErrorField = {};

    if (!data.subject) {
      newErrorField.subject = "Please Enter Subject";
      isError = true;
    } else {
      newErrorField.subject = "";
    }

    setErrorField(newErrorField);
    return !isError;
  };



  return (
    <>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <div className="search_wrap">
                <div className="SearchBox mt-1">
                  <div style={{ marginRight: "10px" }}>
                  </div>
                  {!pagename && (
                    <div
                      style={{ display: "flex", justifyContent: "space-between" }}
                    >
                      <Button
                        type="submit"
                        style={{ marginRight: "10px" }}
                        onClick={() => {
                          setData({});
                          setErrorField({});
                          setAddModal(true);
                        }}
                      >
                        Upload File
                      </Button>
                      <Button
                        type="button"
                        style={{ marginRight: "10px" }}
                        onClick={() => {
                          setNewFolderName("");
                          setNewFolderModal(true);
                        }}
                      >
                        New Folder
                      </Button>
                    </div>
                  )}

                </div>
              </div>
              <h4 className="Title">
                <Link to={-1}>
                  <i className="fa fa-arrow-left"></i>
                </Link>
                Document Files & Folders{" "}
              </h4>
            </div>
            {loader}
            <div className="TableList overflow-auto table-responsive">
              {loader}
              <div className="mb-3">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb" style={{ background: "transparent", padding: 0, margin: 0 }}>
                    {path
                      .split("/")
                      .filter(crumb => crumb.trim() !== "")
                      .map((crumb, index, arr) => {
                        const newPath = arr.slice(0, index + 1).join("/");
                        const isLast = index === arr.length - 1;

                        return (
                          <li
                            key={index}
                            className="breadcrumb-item d-flex align-items-center"
                            style={{ fontSize: "16px", fontWeight: "400" }}
                          >
                            {!isLast ? (
                              <>
                                <span
                                  style={{ cursor: "pointer", color: "#0d6efd" }}
                                  onClick={() => setPath(newPath)}
                                >
                                  {crumb}
                                </span>
                                {/* 👇 only ">" separator, no "/" */}
                                <span style={{ margin: "0 8px", color: "#6c757d" }}>&gt;</span>
                              </>
                            ) : (
                              <span style={{ fontSize: "16px", fontWeight: "400", color: "#495057" }}>
                                {crumb}
                              </span>
                            )}
                          </li>
                        );
                      })}

                  </ol>
                </nav>
              </div>
              <Table bordered className="table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th className="text-center">Type</th>
                    <th>Content</th>
                    <th className="text-center">Size</th>
                    <th className="text-center">View</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {record && record.length > 0 ? (
                    record.map((item, i) => {
                      if (item.type === "folder") {
                        return (
                          <tr key={`f-${i}`}>
                            <td>{i + 1}</td>
                            <td className="text-center">
                              {item.type === "folder" ? (
                                <FolderIcon sx={{ color: "#fcba03", marginRight: "6px" }} />
                              ) : (
                                <InsertDriveFileIcon sx={{ color: "rgb(0 85 188)", marginRight: "6px" }} />
                              )}
                              {/* {item.name} */}
                            </td>

                            <td onClick={() => setPath(path ? `${path}/${item.name}` : item.name)}
                              style={{
                                color: "rgb(13, 110, 253)",
                                cursor: "pointer"
                              }}
                            >{item.name}</td>
                            <td className="text-center">-</td>
                            <td className="text-center">
                              -
                            </td>
                            <td className="text-center">
                              {!pagename && (
                                <div className="d-flex justify-content-center">
                                  <Link
                                    className="m-0"
                                    onClick={() => {
                                      setData({});
                                      setEditModal(true);
                                    }}
                                  >
                                    <IconButton
                                      aria-label="edit"
                                      className="px-1 py-0"
                                      onClick={() => {
                                        setItemToRename(item);
                                        setRenameValue(item.name);
                                        setRenameModal(true);
                                      }}
                                    >
                                      <EditIcon sx={{ color: "#4971B2" }} />
                                    </IconButton>
                                  </Link>
                                  <Link
                                    className="m-0"
                                    onClick={() => {
                                      // setDeleteModal(true);
                                    }}
                                  >
                                    <IconButton
                                      aria-label="delete"
                                      className="px-1 py-0"
                                      onClick={() => setItemToDelete(item)}
                                    >
                                      <DeleteIcon sx={{ color: "#f00" }} />
                                    </IconButton>
                                  </Link>
                                </div>
                              )}

                            </td>
                          </tr>
                        );
                      } else {
                        return (
                          <tr key={`fl-${i}`}>
                            <td>{i + 1}</td>
                            <td className="text-center">
                              {item.type === "folder" ? (
                                <FolderIcon sx={{ color: "#fcba03", marginRight: "6px" }} />
                              ) : (
                                <InsertDriveFileIcon sx={{ color: "rgb(122 122 122)", marginRight: "6px" }} />
                              )}
                              {/* {item.name} */}
                            </td>

                            <td>{item.name}</td>
                            <td className="text-center">{item.size}</td>
                            <td className="text-center">
                              <IconButton color="primary" onClick={() => window.open(item.url, "_blank")}>
                                <RemoveRedEye />
                              </IconButton>
                            </td>
                            <td className="text-center">
                              {!pagename && (
                                <div className="d-flex justify-content-center">
                                  <Link
                                    className="m-0"
                                    onClick={() => {
                                      setData({});
                                      setEditModal(true);
                                    }}
                                  >
                                    <IconButton
                                      aria-label="edit"
                                      className="px-1 py-0"
                                      onClick={() => {
                                        setItemToRename(item);
                                        setRenameValue(item.name);
                                        setRenameModal(true);
                                      }}
                                    >
                                      <EditIcon sx={{ color: "#4971B2" }} />
                                    </IconButton>
                                  </Link>
                                  <Link
                                    className="m-0"
                                    onClick={() => {
                                      // setDeleteModal(true);
                                    }}
                                  >
                                    <IconButton
                                      aria-label="delete"
                                      className="px-1 py-0"
                                      onClick={() => setItemToDelete(item)}
                                    >
                                      <DeleteIcon sx={{ color: "#f00" }} />
                                    </IconButton>
                                  </Link>
                                </div>
                              )}
                            </td>
                          </tr>
                        );
                      }
                    })
                  ) : (
                    <NotFound cols={9} />
                  )}
                </tbody>

              </Table>
            </div>
            {total >= 10 ? (
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={limit}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={(e) => setActivePage(e)}
                />
              </div>
            ) : null}
          </div>
        </div>
        <ModalBox
          title="Create New Folder"
          status={newFolderModal}
          onClose={() => setNewFolderModal(false)}
          size="sm"
          customizedFooter={
            <Button onClick={() => handleUpload()}>
              Create
            </Button>
          }
        >
          <div className="p-3">
            <Input
              className="form-control"
              placeholder="Enter folder name"
              value={newFolderName}
              onChange={(e) => setNewFolderName(e.target.value)}
            />

          </div>
        </ModalBox>
        <ModalBox
          title="Upload File"
          status={addModal}
          onClose={() => setAddModal(false)}
          size="sm"
          customizedFooter={
            <Button onClick={handleFileUpload}>
              Upload
            </Button>
          }
        >
          <div className="p-3">
            <Input
              type="file"
              className="form-control"
              onChange={(e) => setSelectedFile(e.target.files[0])}
            />
          </div>
        </ModalBox>
        <ModalBox
          title="Rename File/Folder"
          status={renameModal}
          onClose={() => setRenameModal(false)}
          size="sm"
          customizedFooter={<Button onClick={handleRename}>Rename</Button>}
        >
          <div className="p-3">
            <Input
              className="form-control"
              value={renameValue}
              onChange={(e) => setRenameValue(e.target.value)}
            />
          </div>
        </ModalBox>
        <ModalBox
          title="Confirm Delete"
          status={!!itemToDelete}
          onClose={() => setItemToDelete(null)}
          size="sm"
          customizedFooter={<Button onClick={handleDelete}>Delete</Button>}
        >
          <p>
            Are you sure you want to delete{" "}
            <b>{itemToDelete?.name}</b>?
          </p>
        </ModalBox>




      </div>


    </>
  );
}
